/**
 * For the logic here, refer to: sources/core-embed/core-embed-application/src/main/java/com/axpm/modules/patient/businessportal/ui/tx/entry/AppointmentEntryView.java
 * @param {string} action
 * @param {string} appointmentTime
 * @returns
 */
export function getTitle(action, appointmentTime) {
  switch (action) {
    case 'CANCELLED_BY_OFFICE':
    case 'CANCELLED_BY_PATIENT':
      return 'Cancelled'

    case 'SCHEDULED':
      return `Scheduled for ${appointmentTime}`
    case 'RESCHEDULED':
      return `Rescheduled for ${appointmentTime}`
    case 'NO_SHOW':
      return `Patient didn't show up for ${appointmentTime}`
    case 'CREATED':
      return 'Appointment Created'

    default:
      return action
  }
}
